export default "__VITE_ASSET__Co443BIP__"